<script setup>
import BrandButton from "@/Components/Brand/BrandButton.vue";
import BrandHeader from "./Partials/BrandHeader.vue";
import BrandFooter from "./Partials/BrandFooter.vue";
</script>

<template>
    <div
        class="brand relative min-h-screen overflow-x-hidden bg-brand-cream font-brand text-brand-navy md:bg-[#102a3d]"
    >
        <!-- Desktop backdrop: radial glow, photo-tile band, Back button.
             max-md:hidden (not bare `hidden md:block`) so the legacy
             .hidden{display:none!important} rule can never pin it closed if
             this layout ever renders alongside app.scss. -->
        <div class="max-md:hidden">
            <!-- Soft radial glow behind the card, echoing the mockup's backdrop -->
            <div
                aria-hidden="true"
                class="pointer-events-none absolute inset-0 bg-[radial-gradient(115%_80%_at_50%_40%,rgba(164,204,233,0.18),rgba(16,42,61,0)_70%)]"
            ></div>

            <!--
                Photo-tile band: single flat export of the red gradient + rotated
                gift collage, pinned at its natural 1512px width and clipped by the
                band, so narrower viewports crop the tiles symmetrically and wider
                ones extend into the matching brand-red fill.
            -->
            <div
                aria-hidden="true"
                class="absolute inset-x-0 top-0 h-[368px] overflow-hidden bg-brand-red"
            >
                <img
                    :src="asset('images/brand/auth-hero-band.webp')"
                    alt=""
                    class="absolute left-1/2 top-0 h-[368px] w-[1512px] max-w-none -translate-x-1/2"
                />
            </div>

            <!-- Primary button (BH-30); navyOnRed so the hover wipe reads on
                 the red band. A full page load back to the guest homepage,
                 same as the header's Create Account. -->
            <BrandButton
                :href="route('home')"
                variant="navyOnRed"
                class="absolute left-4 top-4 z-20 px-5 py-2.5 text-[15px]"
            >
                Back
            </BrandButton>
        </div>

        <!-- Mobile: standard brand chrome instead of the navy backdrop -->
        <div class="md:hidden">
            <BrandHeader />
        </div>

        <main class="relative z-10 px-5 pb-2.5 md:px-4 md:pb-16 md:pt-[51px]">
            <!--
                Mobile: white strip continuing the header panel behind the red
                panel's rounded top corners. Both wrappers dissolve on desktop,
                where the page content sits directly on the navy backdrop.
            -->
            <div
                class="mx-auto max-w-[1472px] rounded-b-[10px] bg-white md:max-w-none md:rounded-none md:bg-transparent"
            >
                <div
                    class="relative overflow-hidden rounded-[10px] bg-brand-red pb-6 pt-[54px] md:overflow-visible md:rounded-none md:bg-transparent md:pb-0 md:pt-0"
                >
                    <!--
                        Flat export of the panel's radial gradient + corner tile
                        cluster; its bottom edge converges to brand red so it
                        blends into the panel fill below.
                    -->
                    <img
                        :src="asset('images/brand/auth-panel-mobile.webp')"
                        alt=""
                        aria-hidden="true"
                        class="absolute inset-x-0 top-0 w-full md:hidden"
                    />

                    <div
                        class="relative flex flex-col items-center px-4 md:px-0"
                    >
                        <slot />
                    </div>
                </div>
            </div>
        </main>

        <div class="md:hidden">
            <BrandFooter />
        </div>
    </div>
</template>
